import { Icon } from "@dmm-com/rocket-web-ui-library";
import * as Styled from "./style";
import { URL } from "~/components/blocks/layout/global-navi/const/url";
import { useHandleClickByDevice } from "~/hooks/use-handle-click-by-device";

type PlanStatusProps = {
  onHideUserMenu: () => void;
};

export const ServicePlanForPremium = (props: PlanStatusProps) => {
  const { onHideUserMenu } = props;
  const { handleClickByDevice } = useHandleClickByDevice();

  const servicePlanLink = () => {
    location.href = URL.contractInfo;
  };

  return (
    <Styled.DivContainer>
      <Styled.ButtonWrapper
        type="button"
        name="account-info"
        aria-label="account-info"
        {...handleClickByDevice(async () => {
          onHideUserMenu();
          servicePlanLink();
        })}
      >
        <div>
          <Styled.ParContentsHead>会員タイプ</Styled.ParContentsHead>
          <Styled.ParContentsValue>
            <span>DMMプレミアム</span>
          </Styled.ParContentsValue>
        </div>
        <Icon name="arrowRight" size="XL" color="GRAY900" />
      </Styled.ButtonWrapper>
    </Styled.DivContainer>
  );
};
